module.exports = __webpack_public_path__ + "static/img/yI-bank.9aa7c39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sureOrder/yI-bank.svg
// module id = xkau
// module chunks = 0